<template>
  <div class="list-wrapper">
    <p class="title arrange">近期课程<span class="class_table" @click='gocalendar'>查看课表<i
      class="updown el-icon-arrow-right"></i></span></p>
    <div class="class_calendar">
      <loop :isLoadCander="isLoadCander"></loop>
    </div>
    <div class="learning_record">
      <p class="record_tip">
        <span class="go_on" @click.stop='go_on(lastname)'><img src="../../../static/images/goon.png" alt="">继续播放</span>
        <span class="lastname">{{lastname.unit_name}}</span>
        <span class="record_enter" @click='gorecord'>学习记录<i class="updown el-icon-arrow-right"></i></span>
      </p>
    </div>
    <div class="member_advertising" v-if="member.isMember == 2">
      <div class="member_tip">
        <p class="member_title"><img src="../../../static/images/vip.png">中公优职会员
          <span v-if="member.isForever == 1" class="use_time">会员终身有效</span>
          <span v-if="member.memberEndTime" class="use_time">{{member.memberEndTime.replace(/-/g, '.')}}到期</span>
        </p>
        <p class="member_zx" v-if="member.memberGoodsRights">
          <img src="../../../static/images/vipkf.png">
          <span
            @click="getWxQr(member.memberGoodsRights)">{{JSON.parse(member.memberGoodsRights[0].detail).label}}</span>
          <span class="vip_index">{{JSON.parse(member.memberGoodsRights[0].detail).badge}}</span>
        </p>
        <p class="member_zx" v-if="member.memberGoodsRights">
          <img src="../../../static/images/vipwx.png">
          <a :href="JSON.parse(member.memberGoodsRights[1].detail).services.url">{{JSON.parse(member.memberGoodsRights[1].detail).label}}</a>
        </p>
      </div>
    </div>
    <p class="title" style="margin-top: 20px;">我的课程</p>
    <van-list :finished="finished" :finished-text="finishedText" :offset="10">
      <div v-for="(item, index) in list" :key="index" class="item"
           @click="getDetail(item.expired_flag, item.system_order_num)">
        <p class="tit">{{ item.name }}</p>
        <div :class="[{'tags':item.sell_point!=''},'tags_both']">
          <span v-if="item.sell_point != ''" v-for="(dat, id) in item.sell_point" :key="id">
            {{
            dat
            }}
          </span>
        </div>
        <div class="expires-time">
          <span class="description" v-if="item.class_data">{{item.class_data}} | <span
            :class="[{'data_hour':item.class_data}]" v-if="item.hour">{{ item.hour }}</span></span>
        </div>
        <div class="expires">{{ item.expires }}</div>
        <div class="teach-box">
          <div class="teachers van-clearfix">
            <div v-for="(data, idx) in item.teachers" :key="idx" v-if='idx<4'>
              <img :src="data.head_image" alt/>
              <p class="teachers_name">{{ data.username }}</p>
            </div>
          </div>
          <div class="seeding-time">
            <p class="go-study">{{item.expired_flag==0?'已过期':'去学习'}}</p>
            <p :class="['detail',{'mt':item.live_time!=''}]">{{item.live_time}}</p>
          </div>
        </div>
      </div>
    </van-list>
    <div class="member-wrapper" v-if="isMember">
      <div class="member-content">
        <p class="kf_title">微信客服<img @click="isMember = false" src="../../../static/images/cancel.png"></p>
        <p class="kf_content">务必添加专属客户经理，<br/>以保证享受会员服务</p>
        <img class="member_img" :src="wxQrcode">
        <p>使用微信扫码添加</p>
      </div>
    </div>
  </div>
</template>
<script>
  import loop from './loop'
  import {List, Toast} from 'vant'
  import 'vant/lib/list/style'
  import record from '../../utils/record.js'

  export default {
    data () {
      return {
        loading: false, //控制列表加载
        finished: false, //列表是否加载完成
        finishedText: '没有更多了',
        refreshing: false, //控制下拉刷新
        list: [], //列表数据
        ticket: '',
        ticket_source: '',
        lastname: [],
        isLoadCander: false,
        ticketObj: {},
        member: [],
        wxQrcode: '',
        isMember: false
      }
    },
    mounted () {
      if (window.location.href.indexOf('#') == 26 || window.location.href.indexOf('#') == 28) {
        var url = window.location.href.replace('#', '')
        console.log(url)
        window.location.href = url
      }
      if (this.$route.query.ticket) {
        this.checklogin()
      } else {
        this.onLoad()
        this.checkMember()
      }
    },
    methods: {
      onLoad () {
        setTimeout(() => {
          this.$api
            .GETLIST(JSON.parse(localStorage.getItem('ticketObj')))
            .then((res) => {
              if (res.code == 0) {
                if (res.data.course && res.data.course.length > 0) {
                  this.finished = true
                  this.refreshing = false
                  this.list = res.data.course
                } else {
                  this.finished = true
                }
                this.lastRecord()
              } else if (res.code == 2 || res.code == 4) {
                sso.ready().then(function (user) {
                  user.logout()
                })
              } else {
                this.finished = true
                this.finishedText = '暂无数据'
              }
            })
            .catch(() => {
            })
        }, 1000)
      },
      checklogin () {
        this.$api.USERINFO({
          'offcn-ticket': this.$route.query.ticket
        }).then(res => {
          if (res.code == 0) {
            this.ticketObj = {
              'offcn-ticket': res.data.ticket,
              ticket_source: res.data.ticket_source,
              sso_id: res.data.sso_user_id,
              name: res.data.user_info.name,
              phone: res.data.user_info.username
            }
            console.log('33333333333'+this.ticketObj)
            window.localStorage.setItem('ticketObj', JSON.stringify(this.ticketObj))
            var that = this
            $.ajax({
              url: (process.env.NODE_ENV=='production' ? '//shop.eoffcn.com': '//shop.t.eoffcn.com') + '/api/user/get_sign?phone=' + JSON.parse(localStorage.getItem("ticketObj")).phone,
              type: 'get',
              success: function (res) {
                if (res.status == 0) {
                  that.ticketObj.sign = res.data.sign
                  window.localStorage.setItem('ticketObj', JSON.stringify(that.ticketObj))
                }
              }
            })
            this.isLoadCander = true
            this.ticket = JSON.parse(localStorage.getItem('ticketObj'))['offcn-ticket']
            this.ticket_source = JSON.parse(localStorage.getItem('ticketObj')).ticket_source
            this.onLoad()
          } else {
            this.$router.push({path: '/'})
          }
        })
      },
      getDetail (flag, orderId) {
        if (flag == 0) {
          Toast('课程已到期，请查看其他内容')
        } else {
          this.$router.push({path: 'list/detail', query: {order_id: orderId}})
        }
      },
      gorecord () {
        this.$router.push({path: 'record'})
      },
      gocalendar () {
        this.$router.push({path: 'calendar'})
      },
      lastRecord () {
        this.ticket = JSON.parse(localStorage.getItem('ticketObj'))['offcn-ticket']
        this.ticket_source = JSON.parse(localStorage.getItem('ticketObj')).ticket_source
        this.name = JSON.parse(localStorage.getItem('ticketObj')).name
        this.$api.LASTSTUDYRECORD({
          'offcn-ticket': this.ticket,
          ticket_source: this.ticket_source,
        }).then((res) => {
          if (res.code == 0) {
            this.lastname = res.data
          } else if (res.code == 2 || res.code == 4) {
            sso.ready().then(function (user) {
              user.logout()
            })
          }
        })
      },
      go_on (item) {
        this.$api.GETCATALOG({
          system_order_num: item.system_order,
          package_id: item.package_id,
          coding: item.coding,
          menu_id: item.unit_id
        }).then((res) => {
          if (res.code == 0) {
            if (item.unit_type == 2) {
              this.$router.push({
                path: '/video',
                query: {
                  order_id: item.system_order,
                  package_id: item.package_id,
                  cid: item.coding,
                  media_id: res.data.catalog.info.video_id,
                  name: item.unit_name,
                  time: item.total_length,
                  id: item.unit_id
                }
              })
            } else if (item.unit_type == 66) {
              if (item.live_type == 3) {
                let info = res.data.catalog.info
                this.$router.push({
                  path: '/livevod',
                  query: {
                    order_id: item.system_order,
                    package_id: item.package_id,
                    cid: item.coding,
                    unit_id: item.unit_id,
                    module_type: 66,
                    url: info.live_record_url
                  }
                })
              }
            }
          } else if (res.code == 2 || res.code == 4) {
            sso.ready().then(function (user) {
              user.logout()
            })
          }
        })
      },
      onRefresh () {
        // 清空列表数据
        this.finished = false
        //  this.refreshing=true;
        this.onLoad()
      },
      checkMember () {
        this.$api.CHECKMEMBER({
          userId: JSON.parse(localStorage.getItem('ticketObj')).sso_id,
          phone: JSON.parse(localStorage.getItem('ticketObj')).phone
        }).then((res) => {
          if (res.code == 0) {
            this.member = res.data
          }
        })
      },
      getWxQr (item) {
        this.wxQrcode = JSON.parse(item[0].detail).wxQrCode
        this.isMember = true
      }
    },
    components: {
      loop
    },
  }
</script>

<style lang="less" scoped>
  /deep/ .van-pull-refresh__head {
    text-align: center;
  }

  .list-wrapper {
    height: 100%;
    margin: 0 auto;
    background: #ffffff;
    padding: 38px 0 43px;
    overflow: scroll;
    .title {
      font-size: 38px;
      color: #333;
      font-weight: bold;
      margin-left: 32px;
      margin-bottom: 30px;
    }
    .arrange {
      margin-right: 30px;
      padding-bottom: 30px;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .class_table {
        font-size: 22px;
        color: #999999;
      }
    }
    .updown {
      font-weight: bold;
      margin-left: 10px;
    }
    .class_calendar {
      padding: 0 30px 30px;
    }
    .learning_record {
      height: 178px;
      padding-left: 32px;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      .record_tip {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 98px;
        color: #4a4a4a;
        font-size: 26px;
        font-weight: bold;
        margin-right: 30px;
        padding: 28px 30px;
        border-radius: 8px;
        background: #ffffff;
        .go_on {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 148px;
          height: 50px;
          font-size: 20px;
          color: #e60012;
          margin-right: 20px;
          border: 1px solid #e60012;
          border-radius: 8px;
          img {
            width: 17px;
            height: 20px;
            margin-right: 10px;
          }
        }
        .lastname {
          width: 308px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .member_advertising {
      height: 160px;
      background: #f5f5f5;
      .member_tip {
        height: 120px;
        border-radius: 8px;
        color: #a46e43;
        background-image: linear-gradient(90deg, #f6e3ca 0%, #e9b47e 100%), linear-gradient(#ffffff, #ffffff);
        margin: 0 30px 32px;
        padding: 14px 30px;
        .member_title {
          font-size: 30px;
          font-weight: bold;
          img {
            margin-right: 20px;
          }
          .use_time {
            font-size: 24px;
            margin-left: 20px;
          }
        }
        .member_zx {
          display: inline-block;
          position: relative;
          width: 244px;
          font-size: 24px;
          margin-top: 10px;
          img {
            vertical-align: middle;
            margin-right: 10px;
          }
          .vip_index {
            position: absolute;
            top: -8px;
            color: #ffffff;
            background: #f87012;
            border-radius: 10px 9px 9px 0px;
            padding: 0 2px;
          }
          a {
            color: #a46e43;
          }
        }
      }
    }
    .record_enter {
      color: #999999;
    }
    .item {
      border-radius: 8px;
      border: 1px solid #e5e5e5;
      margin: 30px;
      padding: 30px;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
      .tit {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 32px;
        font-weight: bold;
        color: #333;
      }
      .tags {
        display: flex;
        margin: 20px 0 20px;
        flex-wrap: wrap;
        span {
          font-size: 20px;
          color: #e60012;
          background: #fce5e7;
          border-radius: 4px;
          margin-right: 10px;
          padding: 2px 9px;
          margin-bottom: 8px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .tags_both {
        margin-bottom: 20px;
      }
      .expires,
      .expires-time {
        font-size: 20px;
        color: #999;
        word-break: break-all;
        .data_hour {
          margin-top: 20px;
        }
      }
      .description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .expires {
        margin: 20px 0 30px;
      }
      .teach-box {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .teachers {
          display: flex;
          width: 60%;
          > div {
            margin-right: 25px;
            text-align: center;
            &:last-child {
              margin-right: 0;
            }
          }
          img {
            width: 65px;
            height: 65px;
            border-radius: 100%;
          }
          .teachers_name {
            color: #999999;
          }
        }
        .seeding-time {
          text-align: right;
          font-size: 20px;
          .go-study {
            display: inline-block;
            margin: 6px 0 0;
            border-radius: 8px;
            border: 1px solid #e5e5e5;
            padding: 14px 18px;
            color: #999;
            text-align: center;
          }
          .detail {
            color: #e60012;
            &.mt {
              margin-top: 20px;
            }
          }
        }
      }
    }
    .member-wrapper {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .6);
      z-index: 1;
      .member-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 500px;
        text-align: center;
        border-radius: 8px;
        background: #ffffff;
        padding: 30px 0;
        .kf_title {
          font-size: 30px;
          img {
            position: absolute;
            top: 30px;
            right: 30px;
          }
        }
        .kf_content {
          margin-top: 20px;
        }
        .member_img {
          width: 250px;
        }
      }
    }
  }

  /deep/ .van-pull-refresh__track {
    position: relative;
    height: 100%;
    .van-list {
      height: 500px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue